interface IconFilterProps {
  className?: string;
  fill?: boolean;
  stroke?: string;
}

const IconFilter: FC<IconFilterProps> = ({ className }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      className={className}
    >
      <path
        d='M5 4H19L14 10.5V20L10 16V10.5L5 4Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default IconFilter;
